import React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { FormikInput } from "components/common";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import {
  DATA_TIERING_LICENSE_TITLE,
  DATA_TIERING_LICENSE_TEXT,
  DATA_TIERING_UPSELL_TITLE,
  DATA_TIERING_UPSELL_TEXT
} from "data-tiering/constants";
import useDataTiering from "./hooks/useDataTiering";
import RepositoryManagement from "./RepositoryManagement";
import WarmTierReadinessInfo from "./WarmTierReadinessInfo";
const TiersConfigurationFields = ({
  valuesPrefix = void 0,
  hiddenFields = [],
  immutableFields = [],
  ignoreFieldRestrictions = true
}) => {
  var _a;
  const { t } = useTranslation("enterprise_data_tiering");
  const { readiness } = useDataTiering();
  const { values } = useFormikContext();
  const sectionDisabled = immutableFields.includes("data_tiering");
  const formValue = (field) => {
    var _a2, _b, _c;
    if (valuesPrefix) {
      return (_b = (_a2 = values[valuesPrefix]) == null ? void 0 : _a2.data_tiering) == null ? void 0 : _b[field];
    }
    return (_c = values == null ? void 0 : values.data_tiering) == null ? void 0 : _c[field];
  };
  const fieldName = (field) => {
    if (valuesPrefix) {
      return `${valuesPrefix}.data_tiering.${field}`;
    }
    return `data_tiering.${field}`;
  };
  const validateMinDaysInHotTier = (value) => {
    const errors = [];
    if (value < 0) {
      errors.push(t("tiers_configuration.negative_numbers"));
    }
    if (value > formValue("index_lifetime_min")) {
      errors.push(t("tiers_configuration.min_hot_tier_too_large"));
    }
    if (errors.length > 0) {
      return errors.join(" ");
    }
    return "";
  };
  const shouldRenderWarmTierReadinessInfo = () => {
    if (ignoreFieldRestrictions || formValue("warm_tier_enabled")) return true;
    if (immutableFields.includes("data_tiering.warm_tier_enabled") || hiddenFields.includes("data_tiering.warm_tier_enabled"))
      return false;
    return true;
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, shouldRenderWarmTierReadinessInfo() && /* @__PURE__ */ React.createElement(WarmTierReadinessInfo, null), ((_a = readiness.data) == null ? void 0 : _a.ready) && /* @__PURE__ */ React.createElement(React.Fragment, null, formValue("warm_tier_enabled") ? /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: t(DATA_TIERING_LICENSE_TEXT),
      title: t(DATA_TIERING_LICENSE_TITLE),
      licenseSubject: LICENSE_SUBJECTS.enterprise,
      bsStyle: "danger"
    }
  ) : /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: t(DATA_TIERING_UPSELL_TEXT),
      title: t(DATA_TIERING_UPSELL_TITLE),
      licenseSubject: LICENSE_SUBJECTS.enterprise
    }
  ), (!hiddenFields.includes("data_tiering.warm_tier_enabled") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      id: "data-tiering-warm-tier-enabled",
      label: t("tiers_configuration.enable_warm_tier"),
      name: fieldName("warm_tier_enabled"),
      help: t("tiers_configuration.enable_warm_tier_help"),
      disabled: (immutableFields.includes("data_tiering.warm_tier_enabled") || sectionDisabled) && !ignoreFieldRestrictions
    }
  ), formValue("warm_tier_enabled") && /* @__PURE__ */ React.createElement(React.Fragment, null, (!hiddenFields.includes("data_tiering.index_hot_lifetime_min") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "number",
      id: "data-tiering-index-hot_lifetime_min",
      label: t("tiers_configuration.min_hot_days"),
      name: fieldName("index_hot_lifetime_min"),
      min: 0,
      max: formValue("index_lifetime_min"),
      validate: (value) => validateMinDaysInHotTier(parseInt(value, 10)),
      help: t("tiers_configuration.min_hot_days_help"),
      disabled: (immutableFields.includes("data_tiering.index_hot_lifetime_min") || sectionDisabled) && !ignoreFieldRestrictions,
      required: true
    }
  ), (!hiddenFields.includes("data_tiering.warm_tier_repository_name") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    RepositoryManagement,
    {
      valuesPrefix,
      disabled: (immutableFields.includes("data_tiering.warm_tier_repository_name") || sectionDisabled) && !ignoreFieldRestrictions
    }
  ))));
};
export default TiersConfigurationFields;
